<template>
  <div class="w-full flex-1-0-auto header-height-top-space">
    <div class="w-full pb-4 xl:pb-6">
      <div class="mb-4 md:px-6 lg:px-8 xl:px-20 xl:mb-8">
        <div class="container">
          <StepNavigation
            :step1="tr('pages.sales.steps.step1')"
            :step2="tr('pages.sales.steps.step2')"
            :step3="tr('pages.sales.steps.step3')"
            :active-step="1"
          />
        </div>
      </div>

      <div id="main-content" class="w-full viewport-gutter pt-4 xl:pt-8">
        <div class="container">
          <div class="space-y-3 text-sm xl:text-lg">
            <h1 class="text-3xl font-bold xl:text-4xl text-4y-sky-blue font-lufthansa-head max-w-220 xl:leading-13 mb-8">
              {{ tr('pages.sales.buy.title') }}
            </h1>
            <p class="leading-7.5 text-2xl max-w-195 font-light">
              {{ tr('pages.sales.buy.description') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full pt-3 pb-16 md:pt-12 md:pb-0">
      <div class="w-full viewport-gutter">
        <div class="container">
          <div class="flex flex-col justify-between w-full xl:flex-row-reverse">
            <VoucherAmountSelector class="w-full py-9 px-10 bg-4y-gray-100 xl:max-w-183" />
            <div class="w-full mb-12 md:flex md:max-w-none md:mb-8 xl:max-w-120 xl:block xl:pr-6 xl:mr-6 xl:mb-0">
              <div class="mt-12 xl:text-lg xl:w-full">
                <ul class="space-y-8 text-4y-gray-900 text-base">
                  <li class="flex flex-row space-x-3">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'w-5 h-5 text-4y-teal-green flex-shrink-0'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M19.525 7.295l-8.712 11.3-6.64-5.345 1.881-2.337 4.254 3.424 6.842-8.874z"/></svg>
                    <span v-html="tr('pages.sales.buy.cards.point1')" />
                  </li>
                  <li class="flex flex-row space-x-3">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'w-5 h-5 text-4y-teal-green flex-shrink-0'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M19.525 7.295l-8.712 11.3-6.64-5.345 1.881-2.337 4.254 3.424 6.842-8.874z"/></svg>
                    <span v-html="tr('pages.sales.buy.cards.point3')" />
                  </li>
                  <li class="flex flex-row space-x-3">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'w-5 h-5 text-4y-teal-green flex-shrink-0'" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M19.525 7.295l-8.712 11.3-6.64-5.345 1.881-2.337 4.254 3.424 6.842-8.874z"/></svg>
                    <span v-html="tr('pages.sales.buy.cards.point4')" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mb-12 xl:mb-12 md:mt-20 xl:mt-40">
        <HowItWorks />
      </div>
    </div>

    <SellerNote />
  </div>
</template>

<script>
import Vue from 'vue'
import HowItWorks from '~brand-components/discover/sale/how-it-works.vue'
import VoucherAmountSelector from '~brand-components/discover/sale/voucher-amount-selector.vue'
import StepNavigation from '~brand-components/discover/navigation/step-navigation.vue'
import SellerNote from '~brand-pages/discover/seller-note.vue'

export default Vue.extend({
  components: {
    SellerNote,
    HowItWorks,
    VoucherAmountSelector,
    StepNavigation,
  },
})
</script>
